// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
export var VerificationMode;
(function (VerificationMode) {
    VerificationMode[VerificationMode["None"] = 0] = "None";
    VerificationMode[VerificationMode["Sms"] = 1] = "Sms";
    VerificationMode[VerificationMode["Email"] = 2] = "Email";
    VerificationMode[VerificationMode["Fixed"] = 3] = "Fixed";
    VerificationMode[VerificationMode["Token"] = 4] = "Token";
    VerificationMode[VerificationMode["SmsPlusEmailOneTimePass"] = 5] = "SmsPlusEmailOneTimePass";
    VerificationMode[VerificationMode["DailySmsPlusEmailOneTimePass"] = 6] = "DailySmsPlusEmailOneTimePass";
    VerificationMode[VerificationMode["GoogleAuthenticator"] = 7] = "GoogleAuthenticator";
})(VerificationMode || (VerificationMode = {}));
export function getTitleFor2FA(mode) {
    switch (mode) {
        case VerificationMode.Sms:
            return Resources.getResource('screen.additionalVerification.title.Sms');
        case VerificationMode.Email:
            return Resources.getResource('screen.additionalVerification.title.Email');
        case VerificationMode.Fixed:
            return Resources.getResource('screen.additionalVerification.title.Fixed');
        case VerificationMode.SmsPlusEmailOneTimePass:
            return Resources.getResource('screen.additionalVerification.title.SmsPlusEmailOneTimePass');
        case VerificationMode.DailySmsPlusEmailOneTimePass:
            return Resources.getResource('screen.additionalVerification.title.DailySmsPlusEmailOneTimePass');
        case VerificationMode.GoogleAuthenticator:
            return Resources.getResource('screen.additionalVerification.title.GoogleAuthenticator');
        case VerificationMode.None:
            return Resources.getResource('screen.additionalVerification.shortTitle');
        default:
            return Resources.getResource('screen.additionalVerification.title');
    }
}
